export const getAllOptionQuery = (fields, child) => {
  return `{
        getAllOptions{id opt_text is_correct is_active  createdAt updatedAt ques{${child.join(
          " "
        )}}}
      }`;
};

export const getallOptionsByQuestionId = (id, fields) => {
  return `{ getOptionsByQuestionID(id:${id}){   id opt_text is_correct is_active createdAt updatedAt counterVote
        question{ 
            id
            ques_text
            is_active
            multiChoice
            sumVote
            created_by
            createdAt 
            updatedAt
             }
    }}`;
};
